import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class AssessmentsController extends Controller {
  // Services
  @service
  router;

  @service
  session;

  @service
  store;

  activeAssessment = null;
}
